<template>
  <link rel="stylesheet" href="CSS/App.css">
  <div>
    <div class="about-header">
      <div>
        <div class="show-bg"></div>
      </div>
      <div class="section1">
        <!-- white foreground to put infront of the background so the text can overlay it easily. -->
        <div class="white-fore2"><img alt="White background image" class="white-fore-image" src="https://i.imgur.com/Xq6hO8N.png" style="border-radius: 30px;">
          <!-- this is an anchor link, so that when they click on the Our Story tab it leads them to this div -->
          <div class="anchor1" id="OurStory"></div>
          <div class="heading">
            <Fade :appear="show" :transition-enter-duration="1200">
              <hr2 :data-column="'about_title'" style="font-size: 120%; line-height: 130%;">{{ BranchPage.about_title
                }}
              </hr2>
            </Fade>
          </div>
          <div class="h1 white-letters">
            <Push :appear="'show'" :transition-enter-duration="1200">
              <hr2 :data-column="'about_header1'" style="font-size: 1.3em">{{ BranchPage.about_header1 }}</hr2>
            </Push>
          </div>
          <div class="gold-line6"></div>
          <div class="center1">
            <div class="p1 para1">
              <Zoom :appear="'show'" :transition-enter-duration="1200">
                <p style="font-family: sans-serif; font-weight: 100;" v-html="BranchPage.about_p1"></p>
              </Zoom>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="anchor" id="Mission"></div>
    <div class="body1">
      <div class="mid-info1">
        <div class="mid-header1">
          <div class="gold-line3"></div>
          <div class="h1 header2">
            <hr2 :data-column="'about_h2'">{{ BranchPage.about_h2 }}</hr2>
          </div>
          <div class="gold-line3"></div>
        </div>
        <div class="text-and-star">
          <Zoom :appear="'show'" :transition-enter-duration="1200">
            <div class="star2"><img alt="Image within a star" :data-column="'about_star2'" :src=BranchPage.about_star2>
            </div>
          </Zoom>
          <div class="h1 white-letters2">
            <hr2 :data-column="'about_h3'" style="font-size: 1.3em">{{ BranchPage.about_h3 }}</hr2>
          </div>
        </div>
        <div class="p1 para2">
          <p :data-column="'about_p2'" style="font-family: sans-serif; font-weight: 100;">{{ BranchPage.about_p2 }}</p>
        </div>
        <div class="mid-header2">
          <div class="anchor" id="Leadership"></div>
          <div class="gold-line"></div>
          <div class="h1 header2">
            <hr2 :data-column="'about_h4'">{{ BranchPage.about_h4 }}</hr2>
          </div>
          <div class="gold-line"></div>
        </div>
        <div class="h1 white-letters3">
          <hr2 :data-column="'about_h5'" style="font-size: 1.3em">{{ BranchPage.about_h5 }}</hr2>
        </div>
        <!-- Differeny buttons that activate a method called OpenLeaderDialog that will, well, open the dialog of the leader clicked on -->
        <div class="leaders" style="margin-top: 100px">
          <div role="button" class="button1">
            <div :data-column="'about_leader1'" @click="OpenLeaderDialog('AJ')" class="zoom"><input type="image"
                style="border-radius: 50%; width: 260px; height: 250px;" :src=BranchPage.about_leader1>
            </div>
          </div>
          <div role="button" class="button2">
            <div :data-column="'about_leader2'" @click="OpenLeaderDialog('John')" class="zoom"><input type="image"
                style="border-radius: 50%; width: 260px; height: 250px;" :src=BranchPage.about_leader2>
            </div>
          </div>
          <div role="button" class="button3">
            <div :data-column="'about_leader3'" @click="OpenLeaderDialog('Eric')" class="zoom"><input type="image"
                style="border-radius: 50%; width: 260px; height: 250px;" :src=BranchPage.about_leader3>
            </div>
          </div>
          <div role="button" class="button4">
            <div :data-column="'about_leader4'" @click="OpenLeaderDialog('Bill')" class="zoom"><input type="image"
                style="border-radius: 50%; width: 260px; height: 250px;" :src=BranchPage.about_leader4>
            </div>
          </div>
          <div role="button" class="button5">
            <div :data-column="'about_leader5'" @click="OpenLeaderDialog('Dan')" class="zoom"><input type="image"
                style="border-radius: 50%; width: 260px; height: 250px;" :src=BranchPage.about_leader5>
            </div>
          </div>
          <div role="button" class="button6">
            <div :data-column="'about_leader6'" @click="OpenLeaderDialog('Dave')" class="zoom"><input type="image"
                style="border-radius: 50%; width: 260px; height: 250px;" :src=BranchPage.about_leader6>
            </div>
          </div>
          <!-- Just the names of the leaders put below each button -->
          <div class="nothing"></div>
          <h1 :data-column="'about_leader1_name'" class="leader1" style="margin-left:40px; padding-top: 50px;">
            {{ BranchPage.about_leader1_name }}</h1>
          <h1 :data-column="'about_leader2_name'" class="leader2" style="margin-left:30px; padding-top: 50px;">
            {{ BranchPage.about_leader2_name }}</h1>
          <h1 :data-column="'about_leader3_name'" class="leader3">{{ BranchPage.about_leader3_name }}</h1>
          <h1 :data-column="'about_leader4_name'" class="leader4" style="margin-left:40px; padding-top: 50px;">
            {{ BranchPage.about_leader4_name }}</h1>
          <h1 :data-column="'about_leader5_name'" class="leader5" style="margin-left:30px; padding-top: 50px;">
            {{ BranchPage.about_leader5_name }}</h1>
          <h1 :data-column="'about_leader6_name'" class="leader6" style="margin-left:15px; padding-top: 50px;">
            {{ BranchPage.about_leader6_name }}</h1>
        </div>
        <div class="mid-header3">
          <div class="anchor" id="Pillars"></div>
          <div class="gold-line"></div>
          <div class="h1 header2">
            <hr2 :data-column="'about_h6'">{{ BranchPage.about_h6 }}</hr2>
          </div>
          <div class="gold-line"></div>
          <div class="h1 header2" style="max-width: 70%; margin-top: 100px; margin-bottom: 100px; margin-left: 15%;">
            <hr2 :data-column="'about_p3'">{{ BranchPage.about_p3 }}</hr2>
          </div>
        </div>
        <!-- 5 Basic Kendo cards with information and such -->
        <div class="card-set1">
          <div class="card1">
            <card class="aboutCards"
              style="width: 375px; border-radius: 5%; height: 525px; background-color: transparent; border-color: #e5e5e5; max-width: 95vw;">
              <cardImage :data-column="'about_card1_img'" :src=BranchPage.about_card1_img></cardImage>
              <cardBody>
                <cardTitle role="heading" :data-column="'about_card1_h'" style="font-size: 1.8em; color: black">
                  {{ BranchPage.about_card1_h }}</cardTitle>
                <div class="gold-line4" style="margin-bottom: 20px; margin-top: 10px"></div>
                <p :data-column="'about_card1_p'" style="font-size: large">{{ BranchPage.about_card1_p }}</p>
              </cardBody>
            </card>
          </div>
          <div class="card2">
            <card class="aboutCards"
              style="width: 375px; border-radius: 5%; height: 525px; background-color: transparent; border-color: #e5e5e5; max-width: 95vw;">
              <cardImage :data-column="'about_card2_img'" :src=BranchPage.about_card2_img>></cardImage>
              <cardBody>
                <cardTitle role="heading" :data-column="'about_card2_h'" style="font-size: 1.8em; color: black">
                  {{ BranchPage.about_card2_h }}</cardTitle>
                <div class="gold-line4" style="margin-bottom: 20px; margin-top: 10px"></div>
                <p :data-column="'about_card2_p'" style="font-size: large" v-html="BranchPage.about_card2_p"></p>
              </cardBody>
            </card>
          </div>
          <div class="card3">
            <card class="aboutCards"
              style="width: 375px; border-radius: 5%; height: 525px; background-color: transparent; border-color: #e5e5e5; max-width: 95vw;">
              <cardImage :data-column="'about_card3_img'" :src=BranchPage.about_card3_img>></cardImage>
              <cardBody>
                <cardTitle role="heading" :data-column="'about_card3_h'" style="font-size: 1.8em; color: black">
                  {{ BranchPage.about_card3_h }}</cardTitle>
                <div class="gold-line4" style="margin-bottom: 20px; margin-top: 1px"></div>
                <p :data-column="'about_card3_p'" style="font-size: large">{{ BranchPage.about_card3_p }}</p>
              </cardBody>
            </card>
          </div>
        </div>
        <div class="card-set2">
          <div class="card4">
            <card class="aboutCards"
              style="width: 375px; border-radius: 5%; height: 525px; background-color: transparent; border-color: #e5e5e5; margin-bottom: 20px; max-width: 95vw;">
              <cardImage :data-column="'about_card4_img'" :src=BranchPage.about_card4_img>></cardImage>
              <cardBody>
                <cardTitle role="heading" :data-column="'about_card4_h'" style="font-size: 1.8em; color: black"
                  v-html="BranchPage.about_card4_h"></cardTitle>
                <div class="gold-line4" style="margin-bottom: 20px; margin-top: 10px"></div>
                <p :data-column="'about_card4_p'" style="font-size: large">{{ BranchPage.about_card4_p }}</p>
              </cardBody>
            </card>
          </div>
          <div class="card5">
            <card class="aboutCards"
              style="width: 375px; border-radius: 5%; height: 525px; background-color: transparent; border-color: #e5e5e5; margin-top: 20px; max-width: 95vw;">
              <cardImage :data-column="'about_card5_img'" :src=BranchPage.about_card5_img></cardImage>
              <cardBody>
                <cardTitle role="heading" :data-column="'about_card5_h'" style="font-size: 1.8em; color: black">
                  {{ BranchPage.about_card5_h }}</cardTitle>
                <div class="gold-line4" style="margin-bottom: 20px; margin-top: 10px"></div>
                <p :data-column="'about_card5_p'" style="font-size: large">{{ BranchPage.about_card5_p }}</p>
              </cardBody>
            </card>
          </div>
        </div>
        <div class="mid-header4" style="margin-top: 175px;">
          <div class="gold-line"></div>
          <div class="h1 header2">
            <hr2 :data-column="'about_h7'">{{ BranchPage.about_h7 }}</hr2>
          </div>
          <div class="gold-line"></div>
        </div>
        <!-- Several different divisions of goldstar, left to right then top to bottom -->
        <p class="about_p6" :data-column="'about_p6'"
          v-html="BranchPage.about_p6"></p>
        <div class="image-section1">
          <div class="collection-1">
            <div class="image-set1">
              <img alt="Goldstar Logo" :data-column="'about_img1'" :src=BranchPage.about_img1 style="height: 80px; margin-top: 40px;">
              <img alt="Equity Logo" :data-column="'about_img3'" :src=BranchPage.about_img3 style="height: 110px; margin-left:50px;">
              <img alt="Home Joans by Jen" :data-column="'about_img2'" :src=BranchPage.about_img2 style="height: 140px; margin-left:50px;">
            </div>
          </div>
          <div class="collection-2">
            <div class="image-set3">
              <img alt="Legacy Mortgage" :data-column="'about_img7'" :src=BranchPage.about_img7 style="height: 50%">
              <img alt="National Home Lending" :data-column="'about_img8'" :src=BranchPage.about_img8 style="height: 40%">
              <img alt="Radiant Mortgage" :data-column="'about_img19'" src="https://i.imgur.com/58sOxHD.png" style="height: 140px; width: auto; margin-left:30px;">
              <img alt="Responsive Mortgage" :data-column="'about_img9'" src="https://i.imgur.com/fif1wIp.png" style="height: 140px; width: auto; margin-left:30px;">
            </div>
          </div>
        </div>
        <!-- Same thing as before but with awards -->
        <div class="mid-header5" style="margin-top: 100px;">
          <div class="anchor" id="Awards"></div>
          <div class="gold-line"></div>
          <div class="h1 header2">
            <hr2 :data-column="'about_h8'">{{ BranchPage.about_h8 }}</hr2>
          </div>
          <div class="gold-line"></div>
        </div>
        <div class="image-section2">
          <div class="image-set5" style="display:flex; justify-content: center">
            <img alt="Rise Winner Award" class="about_img11" :data-column="'about_img11'" :src=BranchPage.about_img11 style="padding-right: 50px">
            <img alt="Top 100 workplaces 2009-2017" class="about_img12" :data-column="'about_img12'" :src=BranchPage.about_img12 style="padding-right: 50px">
            <img alt="Top 100 workplaces 2020" class="about_img13" :data-column="'about_img13'" :src=BranchPage.about_img13 style="padding-right: 50px">
            <img alt="Top mortgage employer 2020" class="about_img14" :data-column="'about_img14'" :src=BranchPage.about_img14 style="padding-right: 50px; height: 100px; max-width: 114px;">
            <img alt="Top mortgage employer 2016" class="about_img15" :data-column="'about_img15'" :src=BranchPage.about_img15 style="padding-right: 50px; height: 100px; max-width: 146px;">
          </div>
          <div class="image-section2">
            <div class="image-set5" style="display:flex; justify-content: center">
            <img alt="America's Fastest Growing Private Companies" class="about_img16" :data-column="'about_img16'" :src=BranchPage.about_img16 style="padding-right: 50px; height: 50%">
            <img alt="Top 100 workplaces 2021" class="about_img17" :data-column="'about_img17'" :src=BranchPage.about_img17 style="padding-right: 50px; height: 50%">
            <img alt="2018 innovation challenge" class="about_img18" :data-column="'about_img18'" :src=BranchPage.about_img18 style="padding-right: 50px; height: 50%">
            <img alt="50 best companies to work for" class="about_img19" :data-column="'about_img19'" :src=BranchPage.about_img19 style="padding-right: 50px; height: 50%">
            <img alt="ICE Inovation Award" class="about_img20" :data-column="'about_img20'" :src=BranchPage.about_img20 style="padding-right: 50px; height: 50%">
            <img alt="EllieMae Hall of Fame 2016" class="about_img21" :data-column="'about_img21'" :src=BranchPage.about_img21 style="height: 50%">
            </div>
          </div>
        </div>
        <div class="mid-header7">
          <div class="h1 header2">
            <hr2 :data-column="'about_h10'" style="font-size: larger;">{{ BranchPage.about_h10 }}</hr2>
            <p style="font-size: 1.1rem; margin-top: 50px;">Join a company where people matter and purpose drives success</p>
          </div>
          <div class="double_button">
            <div class="gold-line5"></div>
            <div class="careers">
              <a role="button" @click="sendTo('/careers')">
                <KButton :data-column="'about_button2'" :size="null" :class="'custom-size3'" :theme-color="'null'"
                  :rounded="'large'">{{ BranchPage.about_button2 }}</KButton>
              </a>
            </div>
            <div class="gold-line5"></div>
          </div>
        </div>
      </div>
    </div>
    <div id="overlay"></div>
    <Dialog class="leaderDiag" v-if="visibleLeaderDialog" :title="leaderName" @close="toggleDialog" :height="500" :width="700">
      <h3 style="padding-left: 30px">{{ leaderTitle }}</h3>
      <p style="max-width: 90%; padding-left: 30px;" v-html="leaderBio"></p>
    </Dialog>
    <Dialog class="mobileLeaderDiag" v-if="visibleMobileLeaderDialog" :title="leaderName" @close="toggleDialog" :height="700" :width="380" :z-index="999999">
      <h3 style="padding-left: 30px">{{ leaderTitle }}</h3>
      <p style="max-width: 90%; padding-left: 30px;" v-html="leaderBio"></p>
    </Dialog>
    <div class="show_bg_about" style="text-align: center">
      <hr2 style="color: #fff; font-size: 4.4em">Leading You Home</hr2>
      <p style="color: white;  margin-top: 50px; padding-bottom: 50px;">Buying, refinancing, or just getting started--our team is here to help</p>
        <a href="mailto:humanresources@goldstarfinancial.com"><KButton :size="null" :class="'custom-size3'" :theme-color="'null'" :rounded="'large'">Contact Us</KButton></a>
    </div>
    <FooterComp></FooterComp>
  </div>
</template>


<script>
import FooterComp from "../components/Footer_Comp.vue"
import { Dialog } from "@progress/kendo-vue-dialogs";
import '@progress/kendo-theme-default/dist/all.css';
import apiService from '../api/api.service';
import { Button as KButton } from "@progress/kendo-vue-buttons";
import { Card, CardBody, CardImage, CardTitle } from "@progress/kendo-vue-layout";
import { Fade, Push, Zoom } from '@progress/kendo-vue-animation';



export default {
  components: {
    FooterComp,
    card: Card,
    cardBody: CardBody,
    cardImage: CardImage,
    cardTitle: CardTitle,
    Dialog,
    KButton,
    'Zoom': Zoom,
    'Push': Push,
    'Fade': Fade,
  },

  name: 'AboutView',
  data: function () {
    const searchParams = new URLSearchParams(window.location.search)
    var orgid = 'HQ';
    if(searchParams.has('org')){
      orgid = searchParams.get('org');
    }

    return {
      show: true,
      orgid: orgid,
      BranchPage: {},
      isLoading: false,
      visibleLeaderDialog: false,
      visibleMobileLeaderDialog: false,
      headerTitle: '',
      leaderBio: '',
      leaderName: '',
      leaderTitle: '',
      leaders: [
        {
          id: 'AJ',
          text: "AJ Franchi is the President & Chief Operating Officer for Gold Star Mortgage Financial Group, Corp, overseeing all business efficiency and ensuring Gold Star’s continued sustainable growth. Franchi’s industry-leading initiatives include the automation of Gold Star’s Secondary Market loan execution and pioneering one of the first customer-facing mobile apps for mortgage lending, GS+, now part of his ConnectGS Platform. His passion for incorporating cutting-edge technology into every aspect of the loan process, recruiting, marketing, and national branching platforms has led to his being considered a strategic thought leader in mortgage technology, providing consulting services from coast to coast.<br><br>Upon graduating with honors from Michigan State University, AJ joined Gold Star in 2008 as an Intern at 22. Fewer than four years passed before he was named Director of Retail Operations for 400 Loan Originators and appointed to Gold Star’s Board of Directors, where he remains their youngest member of record. In 2013, AJ was invited to join Gold Star’s executive leadership team as CIO and tasked with developing and administrating IT Infrastructure and New Technology, Financial Analysis Reporting, and Branch Development. In Franchi's spare time, he serves as a hands-on board member for VETLIFE, a veteran nonprofit whose primary mission is to provide veterans with sustainable solutions while promoting a safer, healthier, and prosperous civilian lifestyle.<br><br>AJ Franchi’s many contributions have led to the following accolades: Ellie Mae’s Hall of Fame for Outstanding Loan Origination Process2013, and Efficiency and ROI in 2014, Tech Savvy Lender by Mortgage Technology Magazine 2013, Mortgage Professional Magazine’s inaugural list of Young Guns2014, and Mortgage Professional Magazine’s Hot 100 2015, National Mortgage Professional Magazine 40 Under 40 2016.",
          name: "AJ Franchi",
          title: "President & Chief Operating Officer"
        },
        {
          id: 'John',
          text: "John Newton is the Chief Information Officer at Gold Star Mortgage Financial Group. Since joining the company in 2016, John has been instrumental in developing and maintaining the organization's IT infrastructure and proprietary technologies. Promoted to CIO in early 2024, his strategic vision and technical expertise have significantly enhanced Gold Star's operational efficiency and technological innovation. John's commitment to leveraging technology for growth and superior service continues to elevate Gold Star’s market presence.",
          name: "John Newton",
          title: "Chief Information Officer"
        },
        {
          id: 'Eric',
          text: "Eric Schultz is an accomplished executive with a decade of experience in banking operations and system development. He currently serves as the Executive Vice President and National Sales Director for Gold Star Mortgage Financial Group. In this role, he is responsible for overseeing the implementation of business development, sales strategies, and operations of Gold Star's branches across the nation, which are engaged in originating, processing, and closing mortgage loans.<br><br>>Eric is an expert in the mortgage industry, having previously worked as a Loan Officer. His deep understanding of the industry has enabled him to create and implement effective strategies that drive business growth. Moreover, his leadership experience at financial institutions such as Chase Bank and Morgan Stanley has equipped him with invaluable skills that are essential to his current role at Gold Star.<br><br>In addition to his responsibilities as National Sales Director, Eric is also in charge of corporate process improvement initiatives. He strives to ensure that Gold Star's processes are constantly evolving and improving to keep pace with the ever-changing market. He also encourages the cultivation of a culture of innovation within the workplace, which fosters an environment of continuous learning and development for all employees.<br><br>Eric earned a Bachelor of Technology from Eastern Michigan University and a Certificate of Professional Development from the Wharton School of Executive Education. His academic background and professional experience have equipped him with the knowledge and skills necessary to excel in his role at Gold Star Mortgage Financial Group. ",
          name: "Eric Schultz",
          title: "Excecutive Vice President & National Sales Director"
        },
        {
          id: 'Bill',
          text: "‍Bill Trainor is the Chief Compliance Officer & General Counsel for Gold Star where he plays acritical role in ensuring that the company operates in full compliance with industry standards and regulations.<br><br>A graduate of the University of Michigan and the University of Detroit Mercy School of Law, Bill is well-versed in risk mitigation, regulatory governance, and compliance in advertising and marketing. He brings a wealth of experience and expertise in the fields of compliance, regulation, and legal affairs. He also possesses deep expertise in the lending industry, which he leverages to help the company navigate the complexities of this field.<br><br>With over a decade of experience in litigation, Bill brings a keen understanding of legal matters to his leadership role at Gold Star. He is recognized as an industry pioneer in digital transactions and is credited with launching United Wholesale Mortgage's virtual e-close platform, which completed the industry's first fully digital, remote e-closing.<br><br>Bill resides in Plymouth, MI, with his wife Amy and their two daughters, and is an active member of his community.",
          name: "Bill Trainor",
          title: "Chief Compliance Officer & General Counsel"
        },
        {
          id: 'Dan',
          text: "Dan Milstein is the Founder and CEO of the Gold Star Family of Companies, including Gold Star Mortgage Financial Group, and ventures in financial services, sports management, publishing, and film production. With over 40 offices nationwide, Dan leads these companies with a vision for excellence and growth. Born in the Soviet Union and immigrating to the U.S. at 16, Dan rose from humble beginnings to become the #1 Loan Officer in the country. He is also a bestselling author, dynamic entrepreneur, and Executive Producer of The Russian Five. Dan’s story of resilience and success has inspired thousands worldwide through his books, consulting, and speaking engagements",
          name: "Dan Milstein",
          title: "Founder & Chief Excecutive Officer"
        },
        {
          id: 'Dave',
          text: "Dave Christmas, the Chief Financial Officer, oversees financial operations, including capital markets, funding, and pricing strategies; since establishing the Secondary Marketing department in 2010, he has driven efficiencies and enhanced execution gains; with a background in operations, compliance, and capital markets, he ensures financial stability while adapting to market dynamics; starting as a loan officer assistant while earning his degree at the University of Michigan, his diverse experience is critical to the company’s financial success.",
          name: "Dave Christmas",
          title: "Chief Financial Officer"
        }
      ]
    };
  },

  mounted() {
    this.GetBranchPage();
  },

  methods: {
    OpenLeaderDialog(leader) {
      var record = this.leaders.find(x => x.id === leader);

      this.leaderBio = record.text;
      this.leaderName = record.name;
      this.leaderTitle = record.title;

      this.toggleDialog();
    },
    GetBranchPage() {
      return apiService.GetBranchPage(this.orgid)
        .then(res => {
          this.BranchPage = res.data.data[0];
          this.isLoading = false;
        }).catch(error => {
          this.isLoading = false;
          console.log(error)
        });
    },
    toggleDialog() {
      var w = window.innerWidth;
      if(w > 430){
      this.visibleLeaderDialog = !this.visibleLeaderDialog;
      }
      else{
        this.visibleMobileLeaderDialog = !this.visibleMobileLeaderDialog;
      }
    },
    sendTo(url) {
      const searchParams = new URLSearchParams(window.location.search)
      if(searchParams.has('org')){
        window.location.href = url + '/?org=' + searchParams.get('org');
      }
      else
        window.location.href = url;
    },
    sendToAnchor(url1, url2) {
      const searchParams = new URLSearchParams(window.location.search)
      if(searchParams.has('org')){
        window.location.href = url1 + '/?org=' + searchParams.get('org') +url2;
      }
      else
        window.location.href = url1 + url2;
    }
  }
};
</script>

<style>
@import '/src/assets/css/aboutView.css';
</style>